var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9715 0H5.60741C5.0113 0 4.52637 0.484961 4.52637 1.08104V3.61831H5.5132V1.08104C5.5132 1.0291 5.55547 0.98683 5.60741 0.98683H13.9715C14.0235 0.98683 14.0657 1.0291 14.0657 1.08104V9.44515C14.0657 9.49712 14.0235 9.53939 13.9715 9.53939H11.5134V10.5262H13.9715C14.5676 10.5262 15.0526 10.0413 15.0526 9.44515V1.08104C15.0525 0.484961 14.5676 0 13.9715 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44515 4.60547H1.08107C0.484961 4.60547 0 5.09043 0 5.68654V14.0506C3.28943e-05 14.6468 0.484961 15.1317 1.08107 15.1317H9.44518C10.0413 15.1317 10.5263 14.6468 10.5263 14.0507V5.68654C10.5263 5.09043 10.0413 4.60547 9.44515 4.60547ZM9.44521 14.1449H1.08107C1.0291 14.1449 0.98683 14.1026 0.98683 14.0507V5.68654C0.98683 5.63457 1.0291 5.5923 1.08107 5.5923H9.44518C9.49715 5.5923 9.53942 5.63457 9.53942 5.68654V14.0507H9.53945C9.53945 14.1026 9.49715 14.1449 9.44521 14.1449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.c3e83fb22f49fd9d17d3f63eb241f4eb.svg";
export { ForwardRef as ReactComponent };